export type methodType = "GET" | "POST" | "PATCH" | "DELETE" | "PUT" | "UPLOAD";
export enum methodEnum {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  DELETE = "DELETE",
  PUT = "PUT",
  UPLOAD = "UPLOAD",
}
